<template>
  <div class="PayInfoWrap">
    <!-- 头部 -->
    <div class="topHeaderWrap"><TopHeader /></div>
    <!-- mobile 返回 -->
    <div class="topPart">
      <div class="return" @click="PaySuccessReturn"></div>
      <a href="https://m.tunnelling.cn/Manager/MemberIndex.aspx"
        ><img :src="imgUrl" alt=""
      /></a>
    </div>
    <!-- 支付成功 -->
    <div class="PaySuccess">
      <div class="PayInfoBox">
        <div class="topInfo">
          <img src="../../assets/img/paySuccess_icon.svg" alt="" />
          <p class="payState">支付成功</p>
          <p class="explain">
            购买成功！您可以在“我的知识平台”-“我的订单”中查看记录。
          </p>
        </div>
        <div class="PayInfo" v-for="(item, index) in orderInfo" :key="index">
          <p><span>订单编号：</span>{{ item.id }}</p>
          <p><span>支付方式：</span>{{ item.paymentWay + "支付" }}</p>
          <p><span>支付时间：</span>{{ item.creationDate }}</p>
          <p>
            <span>实际付款：</span><strong>{{ item.totalPrices }}</strong
            >（元）
          </p>
        </div>
        <div class="btnWrap" v-if="isCartPage === 'cart'">
          <a href="javascript:;" @click="GoBookOrder">查看我的书单</a>
        </div>
        <div class="btnWrap" v-else>
          <a href="javascript:;" @click="GoBookRead">去阅读</a>
          <a href="javascript:;" @click="GoBook">回到图书</a>
        </div>
        <!-- 更多情报 -->
        <MoreNews />
      </div>
    </div>
    <!-- 页脚 -->
    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from "../../components/TopHeader.vue";
import MoreNews from "../../components/MoreNews.vue";
import BottomFooter from "../../components/BottomFooter.vue";
export default {
  name: "PaySuccess",
  data() {
    return {
      orderInfoId: undefined, // 订单id
      orderInfo: [], // 订单
      jugeDevice: true,
      imgUrl: "", // 头像
      InformationId: undefined,
      informationContentId: undefined,
      isCartPage: undefined
    };
  },
  created() {
    this.isCartPage = sessionStorage.getItem("isCart")
      ? sessionStorage.getItem("isCart")
      : this.getQueryString("isCart");
    this.orderInfoId = this.getQueryString("orderInfoId");
    this.InformationId = this.getQueryString("informationId")
      ? this.getQueryString("informationId")
      : sessionStorage.getItem("informationId");
    this.informationContentId = this.getQueryString("informationContentId")
      ? this.getQueryString("informationContentId")
      : sessionStorage.getItem("informationContentId");
  },
  mounted() {
    // 获取用户信息
    this.GetUserInfo();
    // 获取订单详情
    this.GetOrderDetail();
    // 判断加载哪个dom
    let wid = window.innerWidth;
    if (wid >= 320 && wid <= 1024) {
      this.jugeDevice = false;
    }
  },
  methods: {
    // 获取用户信息
    GetUserInfo() {
      this.$fetch("/Login")
        .then(res => {
          if (res.data.accessAllowed === false) return;
          this.imgUrl = res.data.imagePath;
        })
        .catch(err => {
          throw err;
        });
    },
    // 获取订单详情
    GetOrderDetail() {
      this.$fetch("/api/orderInfo/" + this.orderInfoId)
        .then(res => {
          this.orderInfo.push(res.data);
        })
        .catch(err => {
          throw err;
        });
    },
    // 获取url参数
    getQueryString(name) {
      var url = location.href;
      var params = url.split("?");
      var paramsArr = params[1].split("&");
      for (var i = 0; i < paramsArr.length; i++) {
        var paramsVal = paramsArr[i].split("=");
        if (paramsVal[0] == name) return paramsVal[1];
      }
      return false;
    },
    // 去全书阅读
    GoBookRead() {
      // 直接去阅读页面
      let params = {
        InformationId: this.InformationId,
        id: this.informationContentId
      };
      if (this.jugeDevice) {
        let routeData = this.$router.resolve({
          name: "BookRead",
          query: params
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          name: "BookRead",
          query: params
        });
      }
    },
    // 回到图书
    GoBook() {
      let params = {
        InformationId: this.InformationId
      };
      if (this.jugeDevice) {
        let routeData = this.$router.resolve({
          name: "BookDetail",
          query: params
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          name: "BookDetail",
          query: params
        });
      }
    },
    // 查看我的书单
    GoBookOrder() {
      // 我的知识平台
      let href = "https://www.tunnelling.cn/PMember/MyBookList.aspx";
      if (this.jugeDevice) {
        window.open(href, "_blank");
        return;
      }

      this.$router.push("/myBookList");
    },
    // 返回
    PaySuccessReturn() {
      this.$router.go(-1);
    }
  },
  components: {
    TopHeader,
    MoreNews,
    BottomFooter
  }
};
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
  .topHeaderWrap {
    display: none;
  }
  .topPart {
    width: 100%;
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
  }
  .topPart img {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    margin-right: 0.25rem;
  }
  .topPart .return {
    width: 0.4rem;
    height: 0.4rem;
    background: url(../../assets/img/return_mobile.svg) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
  }
  .topInfo {
    border-bottom: 1px solid #eeeeee;
  }
  .PaySuccess {
    padding: 0 0.25rem;
  }
  .PayInfoBox {
    text-align: center;
  }
  .PayInfoBox .explain {
    width: 4.9rem;
  }
  .PayInfo {
    width: 100%;
    margin: 0.5rem 0 0.4rem;
    padding: 0.4rem 0.5rem;
  }
  /* 去阅读+回到书库 */
  .btnWrap {
    margin: 0 0 0.64rem;
  }
  .btnWrap a {
    width: 100%;
    display: block;
    line-height: 0.98rem;
    font-size: 0.36rem;
    border-radius: 4px;
    text-align: center;
  }
  .btnWrap a:first-child {
    color: #ffffff !important;
    background: #2468f2 !important;
  }
  .btnWrap a:last-child {
    background: #f2f2f2;
    color: #333333;
    margin-top: 0.24rem;
  }
}
@media screen and (min-width: 1029px) {
  .topPart {
    display: none;
  }
  .PayInfoBox {
    width: 1200px;
    margin: 0 auto;
    background: #ffffff;
    margin-top: 23px;
    text-align: center;
  }
  .PayInfoBox img {
    margin-top: 64px;
  }
  .PaySuccess {
    background: #fbfbfb;
  }
  .PayInfoBox .explain {
    width: 480px;
  }
  .PayInfo {
    width: 560px;
    margin: 0 auto;
    padding: 24px 88px;
  }
  /* 去阅读+回到书库 */
  .btnWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 74px;
  }
  .btnWrap a:first-child {
    width: 176px;
    line-height: 40px;
    background: #2468f2 !important;
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff !important;
    letter-spacing: 0;
    margin-right: 20px;
  }
  .btnWrap a:last-child {
    width: 127px;
    line-height: 40px;
    background: #f2f2f2;
    border-radius: 4px;
    font-size: 16px;
    color: #424242;
    letter-spacing: 0.69px;
  }
}
.PayInfoWrap {
  width: 100%;
}
.PaySuccess {
  width: 100%;
  overflow: hidden;
}
.PayInfoBox > img {
  margin: 64px 0 24px;
}
.PayInfoBox .payState {
  font-size: 24px;
  color: #333333;
  line-height: 32px;
}
.PayInfoBox .explain {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  line-height: 22px;
  margin: 16px auto 24px;
}
/* 订单信息 */
.PayInfo {
  background: rgba(245, 245, 245, 0.5);
  border-radius: 2px;
  box-sizing: border-box;
  text-align: left;
}
.PayInfo p {
  margin-top: 24px;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
}
.PayInfo p:first-child {
  margin-top: 0;
}
.PayInfo p > span {
  color: #666666;
  margin-right: 14px;
  font-size: 14px;
}
.PayInfo strong {
  font-size: 20px;
  line-height: 28px;
}
.PayInfo p:last-child {
  font-size: 12px;
  color: #333333;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Payment/PaySuccess.vue